import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { object } from "yup";

import { PhotoVerificationInputField } from "./PhotoVerificationInputField";
import { FieldType } from "../types";

export function PhotoVerificationField(
  field: components["schemas"]["PhotoVerificationCheckField"]
): FieldType<components["schemas"]["PhotoVerificationCheckField"]> {
  return {
    field,
    inputElement: (
      <PhotoVerificationInputField key={field.name} field={field} />
    ),
    initialValue:
      field.value &&
      ({
        id: field.value.id,
      } as components["schemas"]["PhotoVerificationCheckField"]["value"]),
    schema: object().required(
      t(
        "Photo verification is required, please ensure you have confirmed the photo."
      )
    ),
  };
}
